import { Injectable } from '@angular/core';
import { PostProcessor, PostProcessorType } from '../post-processor';
import { LoggingService } from '../../logging/logic/logging.service';
import { PostProcessorXML } from 'src/app/_model/dyn-form/dyn-form-xml';
import { DynForm } from 'src/app/_model/dyn-form';
import { IMSObject } from 'src/app/_model/ims-object';
import { RemoteActionUpdateObject } from 'src/app/_model/remote-action/remote-action-builder/remote-action-builder';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { SyncJobsAction } from '../../action-interpreter/action-handlers/sync-jobs-action-handler.service';
import { CargoItemsService } from '../../cargo-item/logic/cargo-item.service';
import { CargoItem } from 'src/app/_model/cargo-item';

@Injectable({
  providedIn: 'root',
})
export class CargoItemsFormFieldPostProcessor implements PostProcessor {
  // Public Member
  constructor(
    private logger: LoggingService,
    private cargoItemsService: CargoItemsService,
  ) {}
  public readonly name: PostProcessorType = 'formpi_cargoitems';
  private key = this.name + '_key';

  // Lifecycle
  async postProcess(
    form: DynForm,
    formData: any,
    imsObject: IMSObject,
    postProcessorXml?: PostProcessorXML,
    remoteAction?: RemoteAction,
  ): Promise<RemoteActionUpdateObject[]> {
    this.logger.log(
      this.constructor.name,
      'save return value on object',
      formData,
      formData?.[formData?.[this.key]],
    );

    const cargoItemsData = formData?.[formData?.[this.key]] ?? [];
    for (const cargoItemData of cargoItemsData) {
      const cargoItem = this.cargoItemsService.getCargoItemById({
        imsId: cargoItemData['id'],
        objRef: 'ims/CargoItem',
      });
      if (!cargoItem) {
        this.logger.warn(
          this.constructor.name,
          'postProcess',
          `Could not find CargoItem`,
          cargoItemData,
          "probably an unplanned cargoitem that was returned, skipping update",
        );
        continue;
      }
      // Duplicate for amtreturn because old PostProcessCargoItem uses returnamt
      cargoItem.amtreturn = cargoItemData['amtreturn'] ?? cargoItemData['returnamt'] ?? 0;
      cargoItem.amtopen = cargoItemData['newamtopen'] ?? 0;
      await this.cargoItemsService.updateCargoItem(cargoItem);
    }

    return undefined;
  }
}
